import React from "react";
import { cn } from "@/lib/utils";

type SettingsContainerProps = {
	children: React.ReactNode;
	className?: string;
};

export const SettingsContainer: React.FC<SettingsContainerProps> = ({
	children,
	className,
}) => {
	return (
		<div className={cn("container mt-4 mx-auto w-[90%]", className)}>
			{children}
		</div>
	);
};
